module.exports = __webpack_public_path__ + "static/media/backend.b049be2d.png";